module.exports = __webpack_public_path__ + "img/fallback-slide.1920x1280.nl.79235b87.png";